export const AppConst = {
	InViewDelay: 1000,
	InViewMargin: '30px 0px 0px 0px',
	Duration: 0.6,
};
